export default __webpack_public_path__ + "static/media/brand_anda.d886ea21.svg";